/**
 * SIM-SZENE LEIPZIG – ResourceBar
 * Zeigt die drei Ressourcen: je eine klare Farbe pro Balken, Prozentsatz lesbar.
 * Kein Rot/Orange/Grün-Gradient – jeder Balken = eine Ressource, Füllstand = Wert.
 */
import { useGameState } from '../state/gameState.jsx';
import './ResourceBar.css';

const RESOURCE_CONFIG = {
  geld:       { label: 'GELD',       icon: '💰', cssVar: '--ad-resource-geld' },
  nerven:     { label: 'NERVEN',     icon: '🧠', cssVar: '--ad-resource-nerven' },
  credibility: { label: 'CREDIBILITY', icon: '😎', cssVar: '--ad-resource-credibility' },
};

const WARN_THRESHOLD = 25;

export function ResourceBar() {
  const { state } = useGameState();
  const { geld, nerven, credibility } = state;
  
  return (
    <div className="resource-bar">
      <div className="resource-grid">
        <ResourceItem key="geld" id="geld" value={geld} />
        <ResourceItem key="nerven" id="nerven" value={nerven} />
        <ResourceItem key="credibility" id="credibility" value={credibility} />
      </div>
    </div>
  );
}

function ResourceItem({ id, value }) {
  const config = RESOURCE_CONFIG[id];
  const isLow = value <= WARN_THRESHOLD;
  
  return (
    <div className={`resource-item resource-item--${id} ${isLow ? 'resource-item--low' : ''}`}>
      <span className="resource-label">
        <span className="resource-icon">{config.icon}</span>
        {config.label}
      </span>
      <div className="resource-bar-container">
        <div
          className="resource-bar-fill"
          style={{
            '--value': `${value}%`,
            '--fill-color': `var(${config.cssVar})`,
          }}
        />
      </div>
      <span className="resource-value" aria-label={`${config.label}: ${value} Prozent`}>
        {value}%
      </span>
    </div>
  );
}
